import React from 'react';
import { createPortal } from 'react-dom';

const addRef = () => {
  if (!window.hasOwnProperty('_reactCallout')) {
    window._reactCallout = {
      refCount: 0,
      domElement: null,
    };
  }
  if (!window._reactCallout.refCount) {
    const body = document.getElementsByTagName('body')[0];
    window._reactCallout.domElement = document.createElement('div');
    body.appendChild(window._reactCallout.domElement);
  }
  window._reactCallout.refCount++;
};

const removeRef = () => {
  if (!window.hasOwnProperty('_reactCallout')) {
    return;
  }
  window._reactCallout.refCount--;
  if (window._reactCallout.refCount === 0) {
    const el = window._reactCallout.domElement;
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
    }
    window._reactCallout.domElement = null;
  }
};

const positionTooltip = (
  tooltipDOMElement,
  targetDOMElement,
  orientation,
  className,
  shown,
  position,
) => {
  const target_offset = ADV.util.getOffset(targetDOMElement);

  if (position === 'fixed') {
    target_offset.top -= ADV.util.getScrollTop(window);
  }

  const target_dim = {
    width: targetDOMElement.offsetWidth,
    height: targetDOMElement.offsetHeight,
  };
  const scope_dim = {
    width: tooltipDOMElement.offsetWidth,
    height: tooltipDOMElement.offsetHeight,
  };

  switch (orientation) {
    case 'left':
      tooltipDOMElement.setAttribute(
        'style',
        shown
          ? `display: block;` +
              `top: ${target_offset.top}px;` +
              `left: ${target_offset.left - scope_dim.width}px;`
          : '',
      );
      tooltipDOMElement.classList.add('orientation-left');
      break;
    case 'top':
      tooltipDOMElement.setAttribute(
        'style',
        `${shown ? `display: block;` : ''}top: ${target_offset.top - scope_dim.height}px;` +
          `left: ${target_offset.left}px;`,
      );
      tooltipDOMElement.classList.add('orientation-top');
      break;
    case 'rightmiddle':
      tooltipDOMElement.setAttribute(
        'style',
        `${shown ? `display: block;` : ''}top: ${target_offset.top +
          (target_dim.height / 2 - scope_dim.height / 2)}px;` +
          `left: ${target_offset.left + target_dim.width}px;`,
      );
      tooltipDOMElement.classList.add('orientation-rightmiddle');
      break;
    case 'right':
      tooltipDOMElement.setAttribute(
        'style',
        `${shown ? `display: block;` : ''}top: ${target_offset.top}px;` +
          `left: ${target_offset.left + target_dim.width}px;`,
      );
      tooltipDOMElement.classList.add('orientation-right');
      break;
    case 'bottom':
      tooltipDOMElement.setAttribute(
        'style',
        `${shown ? `display: block;` : ''}top: ${target_offset.top + target_dim.height}px;` +
          `left: ${target_offset.left}px;`,
      );
      tooltipDOMElement.classList.add('orientation-bottom');
      break;
    case 'bottomleft':
      tooltipDOMElement.setAttribute(
        'style',
        shown
          ? `display: block;` +
              `top: ${target_offset.top + target_dim.height}px;` +
              `left: ${target_offset.left - scope_dim.width - (3 * target_dim.width) / 4}px;`
          : '',
      );
      tooltipDOMElement.classList.add('orientation-bottomleft');
      break;
    case 'custom':
      // do nothing
      break;
  }
};

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.renderTooltip = this.renderTooltip.bind(this);

    this.state = {
      shown: false,
    };

    this.node = null;
    this.anchor = null;
  }

  UNSAFE_componentWillMount() {
    addRef();
    this.node = document.createElement('div');
    window._reactCallout.domElement.appendChild(this.node);
  }

  componentWillUnmount() {
    removeRef();
  }

  renderTooltip(props, state) {
    const {
      tooltipchildren,
      tooltipclassname,
      tooltipStyle,
      tooltipNext,
      tooltipDone,
      orientation,
    } = props;

    const { node } = this;
    const { anchor } = this;

    if (!tooltipchildren) {
      return;
    }
    return createPortal(
      <div
        className={`${tooltipclassname ? `${tooltipclassname} ` : ''}Tooltip`}
        ref={tooltip => {
          if (anchor !== null && tooltip !== null) {
            positionTooltip(tooltip, anchor, orientation, tooltipclassname, state.shown);
          }
        }}
        style={
          state.shown
            ? {
                ...tooltipStyle,
                display: 'block',
              }
            : tooltipStyle
        }
      >
        {tooltipchildren}
        <div className="buttons">
          {tooltipNext ? (
            <button className="btn-next" onClick={() => {}}>
              Next
              <i className="fa fa-angle-right" />
            </button>
          ) : null}
          {tooltipDone ? <button className="btn-done">OK, got it.</button> : null}
        </div>
      </div>,
      node,
    );
  }

  render() {
    const that = this;
    const { tag, children, delay = null } = that.props;

    var timerContainer;

    return (
      <>
        {this.renderTooltip(this.props, this.state)}

        {React.createElement(
          tag,
          {
            ...that.props,
            onMouseOver: () => {
              if (delay && delay >= 0) {
                timerContainer = setTimeout(() => {
                  if (that.state.shown) {
                    return;
                  }
                  that.setState({
                    shown: true,
                  });
                }, delay);
              }
            },
            onMouseEnter: () => {
              if (that.state.shown || (delay && delay >= 0)) {
                return;
              }
              that.setState({
                shown: true,
              });
            },
            onMouseLeave: () => {
              if (timerContainer) {
                clearTimeout(timerContainer);
              }
              if (!that.state.shown) {
                return;
              }
              that.setState({
                shown: false,
              });
            },
            ref: anchor => {
              that.anchor = anchor;
            },
          },
          children,
        )}
      </>
    );
  }
}

export default Tooltip;
